import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-background pt-24 pb-golden-2xl flex items-center justify-center">
      <div className="max-w-lg mx-auto px-golden-md text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="glass-card p-golden-2xl"
        >
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mb-golden-lg"
          >
            <span className="font-data text-8xl font-bold gradient-text">404</span>
          </motion.div>

          <h2 className="text-2xl mb-golden-md text-text-heading">
            Página no encontrada
          </h2>
          <p className="text-text-body mb-golden-xl">
            La página que buscas no existe o ha sido movida. Vuelve al inicio para encontrar lo que necesitas.
          </p>

          <Link to="/" className="btn-primary inline-flex" data-testid="404-home-link">
            <ArrowLeft className="w-5 h-5" />
            Volver al inicio
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
